import { Outlet } from "react-router-dom";
import {
  Layout,
  LayoutHeader,
  LayoutContent,
} from "@jana-technology/platform-ui";

import { NavbarContainer } from "components/navbar";

export const ExportLayout = () => {
  return (
    <Layout>
      <LayoutHeader>
        <NavbarContainer />
      </LayoutHeader>
      <LayoutContent>
        <Outlet />
      </LayoutContent>
    </Layout>
  );
};

export default ExportLayout;
